<div fxLayout="column wrap" fxLayoutGap="10px" *ngIf="houseRules">
    <ng-container *ngFor="let houseRule of houseRules.rules">
        <div fxLayoutAlign="start center"
             *ngIf="houseRule.enabled">
            <!--
            https://stackoverflow.com/questions/50303454/how-to-use-the-new-material-design-icon-themes-outlined-rounded-two-tone-and
            -->
            <img class="size-2" src="{{houseRule.icon}}" *ngIf="houseRule.icon?.startsWith('/')"/>

            <mat-icon class="material-icons-outlined size-2" *ngIf="!houseRule.icon?.startsWith('/')">
                {{houseRule.icon}}
            </mat-icon>

            <span class="size-1"></span>

            <span class="text-medium">{{houseRule.title}}</span>
        </div>
    </ng-container>

    <div class="margin-top-3 text-medium" *ngIf="houseRules.otherRules">
        <app-markdown-renderer [text]="houseRules.otherRules"></app-markdown-renderer>
    </div>
</div>
